import { render } from "./ImportProductosFoco.vue?vue&type=template&id=98e0cb36"
import script from "./ImportProductosFoco.vue?vue&type=script&lang=js"
export * from "./ImportProductosFoco.vue?vue&type=script&lang=js"

import "./ImportProductosFoco.vue?vue&type=style&index=0&id=98e0cb36&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__